/* eslint-disable @typescript-eslint/unbound-method */
export {
  AmplitudeReturn,
  BaseEvent,
  EventOptions,
  IConfig,
  Event,
  IdentifyEvent,
  GroupIdentifyEvent,
  IdentifyOperation,
  SpecialEventType,
  IIdentify,
  IRevenue,
  RevenueProperty,
  ILogger,
  LogLevel,
  Plugin,
  BeforePlugin,
  EnrichmentPlugin,
  DestinationPlugin,
  Result,
  ServerZoneType,
  ServerZone,
  IdentityStorageType,
  Storage,
  TransportType,
  OfflineDisabled,
  NodeClient,
  NodeOptions,
} from '@amplitude/analytics-core';
